import React, { memo } from "react";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import history from "../utils/History";
import Layout from "../modules/Layout/index";
import AuthChecker from "./AuthChecker";
import IdleChecker from "../utils/IdleChecker";
import Home from "../modules/Home";
import CarrierAgreementMgmt from "../modules/CarrierAgreementMgmt";
import CarrierAgreementMgmtOfficeTab from "../modules/OfficeTab";
import Agreements from "../modules/CarrierAgreementMgmt/Agreements";
import OfficeSetting from "../modules/CarrierAgreementMgmt/OfficeSettings";
import DigitalAssets from "../modules/CarrierAgreementMgmt/DigitalAsset";
import PolicyFee from "../modules/PolicyFee";
import Notifications from "../modules/NavBar/Notifications/index";
import Reports from "../modules/CarrierAgreementMgmt/Reports";
import ReportsTab from "../modules/ReportsTab";
import LobTypes from "../modules/Utilities/ProducerConfiguration/LobType";
import Entity from "../modules/Utilities/Entity";
import OfficeStatus from "../modules/Utilities/Office/OfficeStatus";
import OfficeStatusDetails from "../modules/Utilities/Office/OfficeStatusDetails";
import PolicyType from "../modules/Utilities/ConfigureAgreement/PolicyType";
import TargetSystem from "../modules/Utilities/Office/TargetSystem";
import SalesLead from "../modules/Utilities/ConfigureAgreement/SalesLead";
import PolicyTerm from "../modules/Utilities/PolicyTerms";
import ConfigureAgreement from "../modules/Utilities/ConfigureAgreement/index";
import FeeType from "../modules/Utilities/PolicyTerms/FeeType";
import PolicyTerms from "../modules/Utilities/PolicyTerms/Terms";
import EmailRecipientConfiguration from "../modules/Utilities/EmailRecipientConfiguration";
import GLEntity from "../modules/Utilities/Office/GLEntity";
import OfficeDivision from "../modules/Utilities/Office/OfficeDivision";
import OfficeBrands from "../modules/Utilities/Office/OfficeBrand";
import ProducerCodeConfig from "../modules/CarrierAgreementMgmt/ProducerCodeConfig";
import FeeLevel from "../modules/Utilities/PolicyTerms/FeeLevel/index";
import UserModuleandRoleMgt from "../modules/Utilities/UserModuleandRoleMgt";
import ModuleManagement from "../modules/Utilities/UserModuleandRoleMgt/ModuleManagement";
import EmployeeConfiguration from "../modules/Utilities/EmployeeConfiguration";
import ProducerConfiguration from "../modules/Utilities/ProducerConfiguration/index";
import OfficeHierarchyConfiguration from "../modules/Utilities/OfficeHierarchyConfiguration";
import OfficeConfiguration from "../modules/Utilities/Office/index";
import NavBar from "../modules/NavBar";
import Footer from "../modules/Footer";
import EmployeeStatus from "../modules/Utilities/EmployeeConfiguration/EmployeeStatus";
import EmployeeType from "../modules/Utilities/EmployeeConfiguration/EmployeeType";
import EmploymentType from "../modules/Utilities/EmployeeConfiguration/EmploymentType";
import LicenseType from "../modules/Utilities/ConfigureAgreement/LicenseType";
import BusinessType from "../modules/Utilities/ConfigureAgreement/BusinessType";
import OfficeType from "../modules/Utilities/Office/OfficeType";
import Employees from "../modules/CarrierAgreementMgmt/Employees/Confie";
import OfficeHierarchy from "../modules/CarrierAgreementMgmt/OfficeHierarchy";
import { Permission } from "../modules/Utilities/UserModuleandRoleMgt/Permission";
import Standard from "../modules/Utilities/ConfigureAgreement/Standard";
import OfficeBrand from "../modules/Utilities/Office/OfficeBrand";
import Channel from "../modules/Utilities/Office/Channel";
import SalesType from "../modules/Utilities/Office/SalesType";
import OfficeOrigin from "../modules/Utilities/Office/OfficeOrigin";
import BusinessOperation from "../modules/Utilities/BusinessOperation";
import CarrierProgram from "../modules/Utilities/ProducerConfiguration/CarrierProgram";
import OperationsGroup from "../modules/Utilities/GroupConfiguration";
import DistributionChannel from "../modules/Utilities/ProducerConfiguration/DistributionChannel";
import MGA from "../modules/Utilities/ProducerConfiguration/MGA";
import EmailWorkFlow from "../modules/Utilities/EmailRecipientConfiguration/EmailWorkFlow";
import LineOfBusiness from "../modules/Utilities/ConfigureAgreement/LineOfBusiness";
import AgencyMapping from "../modules/Utilities/ConfigureAgreement/AgencyMapping";
import CodeLevel from "../modules/Utilities/ProducerConfiguration/CodeLevel";
import Risk from "../modules/Utilities/ConfigureAgreement/Risk";
import EmailRecepient from "../modules/Utilities/EmailRecipientConfiguration/EmailRecipient";
import EmployeeTitle from "../modules/Utilities/EmployeeConfiguration/EmployeeTitle";
import EmailDomain from "../modules/Utilities/EmployeeConfiguration/EmailDomains";
import EmployeeBilingual from "../modules/Utilities/EmployeeConfiguration/EmployeeBilingual";
import LeasedEquipmentConfiguration from "../modules/Utilities/LeasedEquipmentConfiguration/index";
import EmployeeTab from "../modules/EmployeeTab";
import VendorTab from "../modules/VendorTab";
import Utilities from "../modules/Utilities";
import SecurityConfiguration from "../modules/Utilities/SecurityConfiguration";
import DataConnection from "../modules/Utilities/SecurityConfiguration/DataConnection";
import AlarmType from "../modules/Utilities/SecurityConfiguration/AlarmType";
import DVRType from "../modules/Utilities/SecurityConfiguration/DVRType";
import CameraSystem from "../modules/Utilities/SecurityConfiguration/CameraSystem";
import FileCategory from "../modules/Utilities/SecurityConfiguration/FileCategory";
import WarrantyCoverage from "../modules/Utilities/SecurityConfiguration/WarrantyCoverage";
import SafeType from "../modules/Utilities/SecurityConfiguration/SafeType";
import CameraType1 from "../modules/Utilities/SecurityConfiguration/CameraType1";
import CameraType2 from "../modules/Utilities/SecurityConfiguration/CameraType2";
import LeasedEquipmentType from "../modules/Utilities/LeasedEquipmentConfiguration/Type";
import LeasedEquipmentMake from "../modules/Utilities/LeasedEquipmentConfiguration/Make";
import LeasedEquipmentModel from "../modules/Utilities/LeasedEquipmentConfiguration/Model";
import TexasGrouping from "../modules/Utilities/Office/TexasGrouping";
import BusinessLicencesPermits from "../modules/Utilities/BusinessLicensesPermitsConfiguration";
import EmployeeReportsTo from "../modules/Utilities/EmployeeConfiguration/EmployeeReportsTo";
import SafeMake from "../modules/Utilities/SecurityConfiguration/SafeMake";
import OfficeDepartment from "../modules/Utilities/Office/OfficeDepartment";
import ExpenseAccount from "../modules/Utilities/VendorConfiguration/ExpenseAccount";
import OnlineDirectories from "../modules/Utilities/DigitalAssetsConfiguration/OnlineDirectories";
import DynamicReports from "../modules/CarrierAgreementMgmt/ReportsDynamic/DynamicReports";
import ReportsTabIndex from "../modules/CarrierAgreementMgmt/ReportsDynamic";
import AcquisitionConfiguration from "../modules/Utilities/Office/AcquisitionConfiguration/index";

const ProtectedRoute = ({ children, path, ...rest }) => {
  const isAuth = localStorage.getItem("token");

  if (!isAuth) {
    return <Redirect to="/login" />;
  }
  return (
    <div className="h-screen">
      <NavBar />
      <main className="bg-white h-fit">
        <div className={`${path === "/home" ? "bg-LightWhite" : ""}`}>
          {/* <Switch> */}
          <Route {...rest} path={path}>
            {children}
          </Route>
          {/* </Switch> */}
        </div>
        <div
          className={`${
            path === "/home" ? "bg-LightWhite" : "py-6 sm:px-6 1g:px-8"
          }`}
        >
          <Footer />
        </div>
      </main>
    </div>
  );
};

const Routes = () => {
  return (
    <Router history={history}>
      <IdleChecker>
        <Switch>
          <ProtectedRoute path="/home">
            <Home />
          </ProtectedRoute>
          <ProtectedRoute path="/CarrierAgreementMgmt">
            <CarrierAgreementMgmt />
          </ProtectedRoute>
          <ProtectedRoute path="/officesettings">
            <CarrierAgreementMgmtOfficeTab />
          </ProtectedRoute>
          <ProtectedRoute path="/employeetab">
            <EmployeeTab />
          </ProtectedRoute>
          <ProtectedRoute path="/vendortab">
            <VendorTab />
          </ProtectedRoute>
          <ProtectedRoute path="/reportstab">
            <ReportsTab />
          </ProtectedRoute>
          <ProtectedRoute path="/utilitiestabs">
            <Utilities />
          </ProtectedRoute>
          <ProtectedRoute path="/carrieragreementmgmt/agreements">
            <Agreements />
          </ProtectedRoute>
          <ProtectedRoute path="/carrieragreementmgmt/officesetting">
            <OfficeSetting />
          </ProtectedRoute>
          <ProtectedRoute path="/carrieragreementmgmt/producercodeconfig">
            <ProducerCodeConfig />
          </ProtectedRoute>
          <ProtectedRoute path="/carrieragreementmgmt/employee">
            <Employees />
          </ProtectedRoute>
          <ProtectedRoute path="/officesettings/officehierarchy">
            <OfficeHierarchy />
          </ProtectedRoute>
          <ProtectedRoute path="/carrieragreementmgmt/digitalasset">
            <DigitalAssets />
          </ProtectedRoute>
          <ProtectedRoute path="/policyfee">
            <PolicyFee />
          </ProtectedRoute>
          <ProtectedRoute path="/notifications">
            <Notifications />
          </ProtectedRoute>
          <ProtectedRoute path="/reports">
            <Reports />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Entity/index">
            <Entity />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office">
            <OfficeConfiguration />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office/OfficeStatus">
            <OfficeStatus />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office/OfficeStatusDetails">
            <OfficeStatusDetails />
          </ProtectedRoute>
          <ProtectedRoute path=" /utilities/Office/OfficeStatus">
            <OfficeStatus />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/office/officeType">
            <OfficeType />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office/Channel">
            <Channel />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office/SalesType">
            <SalesType />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office/OfficeOrigin">
            <OfficeOrigin />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office/GLEntity">
            <GLEntity />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office/OfficeDivision">
            <OfficeDivision />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office/OfficeBrand">
            <OfficeBrand />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office/BusinessOperation">
            <BusinessOperation />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office/OfficeStatusDetails">
            <OfficeStatusDetails />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/ProducerConfiguration">
            <ProducerConfiguration />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/GroupConfiguration">
            <OperationsGroup />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/ProducerConfiguration/LobType">
            <LobTypes />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/ProducerConfiguration/CodeLevel">
            <CodeLevel />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office/MGA">
            <MGA />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/ProducerConfiguration/CarrierProgram">
            <CarrierProgram />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/ProducerConfiguration/DistributionChannel">
            <DistributionChannel />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/configureagreement">
            <ConfigureAgreement />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/configureagreement/policytype">
            <PolicyType />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office/targetsystem">
            <TargetSystem />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/configureagreement/licensetype">
            <LicenseType />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/configureagreement/saleslead">
            <SalesLead />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/configureagreement/standard">
            <Standard />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/configureagreement/businesstype">
            <BusinessType />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/configureagreement/lineofbusiness">
            <LineOfBusiness />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/configureagreement/agencymapping">
            <AgencyMapping />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/configureagreement/risk">
            <Risk />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/PolicyTerm">
            <PolicyTerm />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/PolicyTerm/feelevel">
            <FeeLevel />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/PolicyTerm/feetype">
            <FeeType />
          </ProtectedRoute>
          <ProtectedRoute path="utilities/OfficeHierarchyConfiguration/index">
            {/* <District /> */}
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/PolicyTerm/terms">
            <PolicyTerms />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/EmailRecipientConfiguration">
            <EmailRecipientConfiguration />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/LeasedEquipmentConfiguration">
            <LeasedEquipmentConfiguration />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/EmailRecipientConfiguration/EmailRecipient">
            <EmailRecepient />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/EmailRecipientConfiguration/EmailWorkFlow">
            <EmailWorkFlow />
          </ProtectedRoute>

          <ProtectedRoute exact path="/utilities/SalesLead/index">
            <SalesLead />
          </ProtectedRoute>
          {/* <ProtectedRoute path="/utilities/Office">
            <OfficeConfiguration />
          </ProtectedRoute> */}
          <ProtectedRoute path="/utilities/OfficeHierarchyConfiguration">
            <OfficeHierarchyConfiguration />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office/GLEntity">
            <GLEntity />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office/OfficeBrand">
            <OfficeBrands />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office/OfficeStatus">
            <Layout />
          </ProtectedRoute>
          {/* <ProtectedRoute path="/utilities/Office/OfficeType">
            <OfficeType />
          </ProtectedRoute> */}
          <ProtectedRoute path="/utilities/Office/OfficeStatusDetails">
            <OfficeStatusDetails />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/Office/Saleslead">
            <OfficeStatus />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/UserModuleandRoleMgt/index">
            <UserModuleandRoleMgt />
          </ProtectedRoute>
          <ProtectedRoute
            exact={true}
            path="/utilities/UserModuleandRoleMgt/Permission/:id"
          >
            <Permission />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/UserModuleandRoleMgt/ModuleManagement/index">
            <OfficeStatus />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/UserModuleandRoleMgt/ModuleManagement/index">
            <ModuleManagement />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/EmployeeConfiguration">
            <EmployeeConfiguration />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/EmployeeConfiguration">
            <EmployeeConfiguration />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/EmployeeConfiguration/EmployeeStatus">
            <EmployeeStatus />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/EmployeeConfiguration/EmployeeType">
            <EmployeeType />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/EmployeeConfiguration/EmploymentType">
            <EmploymentType />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/EmployeeConfiguration/EmployeeTitle">
            <EmployeeTitle />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/EmployeeConfiguration/EmployeeReportsTo">
            <EmployeeReportsTo />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/EmployeeConfiguration/EmailDomain/index">
            <EmailDomain />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/EmployeeConfiguration/EmployeeBilingual/index">
            <EmployeeBilingual />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/SecurityConfiguration">
            <SecurityConfiguration />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/SecurityConfiguration/DataConnection">
            <DataConnection />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/SecurityConfiguration/AlarmType">
            <AlarmType />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/SecurityConfiguration/DVRType">
            <DVRType />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/SecurityConfiguration/CameraSystem">
            <CameraSystem />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/SecurityConfiguration/FileCategory">
            <FileCategory />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/SecurityConfiguration/WarrantyCoverage">
            <WarrantyCoverage />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/SecurityConfiguration/SafeType">
            <SafeType />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/SecurityConfiguration/SafeMake">
            <SafeMake />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/SecurityConfiguration/CameraType1">
            <CameraType1 />
          </ProtectedRoute>
          <ProtectedRoute path="/utilities/SecurityConfiguration/CameraType2">
            <CameraType2 />
          </ProtectedRoute>
          <ProtectedRoute path="/utilitiestabs/LeasedEquipmentConfiguration/Type">
            <LeasedEquipmentType />
          </ProtectedRoute>
          <ProtectedRoute path="/utilitiestabs/LeasedEquipmentConfiguration/Make">
            <LeasedEquipmentMake />
          </ProtectedRoute>
          <ProtectedRoute path="/utilitiestabs/LeasedEquipmentConfiguration/Model">
            <LeasedEquipmentModel />
          </ProtectedRoute>
          <ProtectedRoute path="/utilitiestabs/Office/TexasGrouping/index">
            <TexasGrouping />
          </ProtectedRoute>
          <ProtectedRoute path="/utilitiestabs/BusinessLicensesPermitsConfiguration/index">
            <BusinessLicencesPermits />
          </ProtectedRoute>
          <ProtectedRoute path="/utilitiestabs/Office/OfficeDepartment/Index">
            <OfficeDepartment />
          </ProtectedRoute>
          <ProtectedRoute path="/utilitiestabs/VendorConfiguration/ExpenseAccount/Index">
            <ExpenseAccount />
          </ProtectedRoute>

          <ProtectedRoute path="/utilitiestabs/DigitalAssetsConfiguration/OnlineDirectories/index">
            <OnlineDirectories />
          </ProtectedRoute>

          <ProtectedRoute path="/utilitiestabs/Office/AcquisitionConfiguration/index">
            <AcquisitionConfiguration />
          </ProtectedRoute>
          <Route path="/">
            <AuthChecker />
          </Route>
          <Route path="/utilities/ModuleManagement/index">
            <Layout />
          </Route>
        </Switch>
      </IdleChecker>
    </Router>
  );
};
export default memo(Routes);
